var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.638672)",
    fill: "url(#paint0_linear_935_1763)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16 22.8587V13.1987H11.8V22.8587H9.16ZM10.48 11.6387C10.0533 11.6387 9.7 11.4987 9.42 11.2187C9.14 10.9253 9 10.5653 9 10.1387C9 9.72534 9.14 9.372 9.42 9.07867C9.7 8.78534 10.0533 8.63867 10.48 8.63867C10.92 8.63867 11.2733 8.78534 11.54 9.07867C11.82 9.372 11.96 9.72534 11.96 10.1387C11.96 10.5653 11.82 10.9253 11.54 11.2187C11.2733 11.4987 10.92 11.6387 10.48 11.6387Z",
    fill: "#F8F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8209 22.8587V17.3187C20.8209 16.7453 20.6409 16.2787 20.2809 15.9187C19.9209 15.5587 19.4543 15.3787 18.8809 15.3787C18.5076 15.3787 18.1743 15.4587 17.8809 15.6187C17.5876 15.7787 17.3543 16.0053 17.1809 16.2987C17.0209 16.592 16.9409 16.932 16.9409 17.3187L15.9209 16.7987C15.9209 16.0387 16.0809 15.3787 16.4009 14.8187C16.7343 14.2453 17.1876 13.7987 17.7609 13.4787C18.3476 13.1587 19.0076 12.9987 19.7409 12.9987C20.4476 12.9987 21.0809 13.1787 21.6409 13.5387C22.2009 13.8853 22.6409 14.3453 22.9609 14.9187C23.2809 15.4787 23.4409 16.0853 23.4409 16.7387V22.8587H20.8209ZM14.3209 22.8587V13.1987H16.9409V22.8587H14.3209Z",
    fill: "#F8F9F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_935_1763",
    x1: -2.26046e-7,
    y1: 29.1589,
    x2: 32.5836,
    y2: 27.0708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.06abea8a3f082bf772c40b979a7dedf7.svg";
export { ForwardRef as ReactComponent };